import { gql } from '@apollo/client'
import { HEALTH_DATA_REPORT_FIELDS } from '@screens/Nora/graphql/fragments/health_data_report.ts'

export const HEALTH_DATA_REPORT = gql`
  ${HEALTH_DATA_REPORT_FIELDS}
  query healthDataReport($id: ID!) {
    healthDataReport(id: $id) {
      ...HealthDataReportFields
    }
  }
`
